import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectAllAgentsEnums } from "../../../../enumerations/ducks";
import { AgentType } from "../../../enums";
import { Agent } from "../../../types";
import { formatAgentName } from "../../../utils";

type Props = {
  agent: Agent;
};

export const AgentImportantInfoView = ({ agent }: Props) => {
  const { t } = useTranslation();

  const agentParentEnum = useSelector(selectAllAgentsEnums).find(agentEnum => agentEnum.id === agent.parent?.id);

  return (
    <div className="sub-header-info standard-text margin-bottom-small">
      {[
        agent.directorate ? (
          <>
            <span>{t("agent.attrs.directorate")}:</span> {agent.directorate.code}
          </>
        ) : undefined,
        agent.parent ? (
          <>
            <span>{t("agent.attrs.parentId")}:</span> {formatAgentName(agent.parent)}
          </>
        ) : undefined,
        agentParentEnum && agentParentEnum.type === AgentType.LEGAL && agentParentEnum.representatives?.length ? (
          <>
            <span>{t("agent.helpers.parentRepresentatives")}:</span>{" "}
            {agentParentEnum.representatives?.map(representative => formatAgentName(representative)).join(", ")}
          </>
        ) : undefined
      ]
        .filter(item => !!item)
        .reduce<React.ReactNode[]>((acc, element, index) => {
          if (index > 0) {
            acc.push(<Fragment key={index}> | </Fragment>);
          }

          acc.push(<Fragment key={index + "element"}>{element}</Fragment>);
          return acc;
        }, [])}
    </div>
  );
};
